import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { getBlogPost } from '../utils/blogLoader';
import ReactMarkdown from 'react-markdown';

const BlogPost: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const blog = getBlogPost(id || '');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!blog) {
    return <div>Blog post not found</div>;
  }

  return (
    <article className="pt-8 pb-16">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-4xl font-medium mb-2 text-dev-text">{blog.title}</h1>
        <div className="text-dev-text-muted mb-1 flex items-center gap-1">
          <span>{blog.date}</span>
          <span className="mx-0.5">·</span>
          <span>{blog.readTime}</span>
        </div>
        <div className="flex flex-wrap gap-1.5 mb-4">
          {blog.tags.map((tag, index) => (
            <span key={index} className="tech-badge">
              {tag}
            </span>
          ))}
        </div>
        <div className="prose dark:prose-invert max-w-none text-center">
          <ReactMarkdown>{blog.content || ''}</ReactMarkdown>
        </div>
      </div>
    </article>
  );
};

export default BlogPost; 